import React, { FC, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Media } from "@/services/bedrock";

interface OwnProps {
  media: Media;
}

type Props = OwnProps;

export const MediaPlayer: FC<Props> = ({ media }: Props) => {
  const [playWhenReady, setPlayWhenReady] = useState(false);
  const [mediaPlaying, setMediaPlaying] = useState(false);
  const [mediaReady, setMediaReady] = useState(false);

  useEffect(() => {
    if (playWhenReady && mediaReady) {
      setMediaPlaying(true);
    }
  }, [playWhenReady, mediaReady]);

  return (
    <div className="w-full h-full flex items-center justify-center">
      {media?.category === "VIDEO" && (
        <ReactPlayer
          url={media?.uri}
          width="100%"
          height="auto"
          controls
          playsinline
          playing={mediaPlaying}
          onClickPreview={() => {
            setPlayWhenReady(true);
          }}
          onReady={() => {
            setMediaReady(true);
          }}
          onPause={() => setMediaPlaying(false)}
        />
      )}
      {media?.category === "IMAGE" && (
        <img src={media?.uri} className="max-w-full max-h-full object-contain rounded-md" alt="Media Thumbnail" />
      )}
    </div>
  );
};
